import { ConfirmationDialogData } from './components/confirmation-modal/confirmation-dialog.component';

export const MAT_DIALOG_CONFIG_DATA_INSUFFICIENT_CREDIT_AMOUNT_ERROR: ConfirmationDialogData =
    {
        headerTranslationKey: 'shared.errorMessages.defaultHeader',
        confirmationQuestion: {
            translationKey:
                'shared.errorMessages.insufficientCreditAmount.question',
            interpolateParameters: null,
        },
        confirmButtonTranslationKey: null,
        rejectButtonTranslationKey:
            'shared.errorMessages.defaultAcknowledgeButtonText',
        transferData: false,
    };

export function createFreePlanImageLimitExceededErrorDialogData(
    remainingImageCount: number
): ConfirmationDialogData {
    return {
        headerTranslationKey: 'shared.errorMessages.defaultHeader',
        confirmationQuestion: {
            translationKey:
                'shared.errorMessages.freePlanImageLimitExceeded.question',
            interpolateParameters: { remainingImageCount },
        },
        confirmButtonTranslationKey: null,
        rejectButtonTranslationKey:
            'shared.errorMessages.defaultAcknowledgeButtonText',
        transferData: false,
    };
}

export function createFreePlanUploadSelectionLimitExceededDialogData(
    uploadLimit: number
): ConfirmationDialogData {
    return {
        headerTranslationKey: 'shared.errorMessages.defaultHeader',
        confirmationQuestion: {
            translationKey:
                'shared.errorMessages.freePlanUploadSelectionLimitExceeded.question',
            interpolateParameters: { uploadLimit },
        },
        confirmButtonTranslationKey: null,
        rejectButtonTranslationKey:
            'shared.errorMessages.defaultAcknowledgeButtonText',
        transferData: false,
    };
}
